import React from "react";
import Swal from "sweetalert2";
import { Icon } from "@iconify/react";
import iconoDescargar from "@iconify/icons-mdi/cellphone-arrow-down";
import { usePuedeInstalarse } from "../../../hooks/usePwa";
import { esAppInstalada, esIOS, instalarApp } from "../../../pwa/instalacionApp";
import style from "../../../styles/landing.module.scss";

// Instrucciones cuando el navegador no ofrece el diálogo de instalación directo
const mostrarInstrucciones = () => {
    const pasos = esIOS()
        ? "En Safari toca el botón Compartir (cuadro con flecha hacia arriba) y elige \"Agregar a inicio\"."
        : "Abre el menú del navegador (⋮) y elige \"Instalar aplicación\" o \"Agregar a la pantalla de inicio\".";

    Swal.fire({
        title: "Instalar la app",
        text: pasos,
        icon: "info",
        confirmButtonText: "Entendido",
    });
};

// Botón "Descargar app": instala la PWA con el logo de Maderas El Paca.
// No se muestra si ya se está usando la app instalada.
const BotonInstalarAppComponent = ({ styleGroup = "" }) => {
    const puedeInstalarse = usePuedeInstalarse();

    if (esAppInstalada()) return null;

    const instalar = () => (puedeInstalarse ? instalarApp() : mostrarInstrucciones());

    return (
        <button type="button" className={`${style.boton_principal} ${styleGroup}`} onClick={instalar}>
            <Icon icon={iconoDescargar} aria-hidden="true" /> Descargar app
        </button>
    );
};

export default BotonInstalarAppComponent;
